import { Trip } from "../../DataStructures/Trip/Trip";
import { Area } from "../../DataStructures/Area/Area";
import { map } from "rxjs/operator/map";
import * as moment from 'moment';

export class GroupTripsByHour {


    groups = new Map<string, Trip>();

    constructor() {

    }

    group(trip: Trip): Map<string, Trip> {

        trip.areas.forEach(a => {
            var time = moment(a.slotTime).toDate().toString();
            var key = Trip.createSubTripKey(moment(new Date(time)));
            if (this.groups.get(key) == null) {

                var areas = this.getAreasMatchingTime(trip, time);
                     
                this.groups.set(key, new Trip(trip.source, trip.destination,areas,trip.centralPoint));
            }
        });

        return this.groups;
    }

    private getAreasMatchingTime(t: Trip, time: string): Array<Area> {

        return t.areas.filter(x => moment(x.slotTime).toDate().toString() == time);
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/TripGroup/GroupTripsByHour.ts